import ViewController from "core/views/view.controller";
import Highcharts from "highcharts/highcharts";
import HighchartsTreeMap from "highcharts/modules/treemap";
import _ from "lodash/lodash";

HighchartsTreeMap(Highcharts);

export default class ChartWorkloadColorsMapCtrl extends ViewController {
    static $inject = ['$scope', 'screenSize'];

    constructor() {
        super(...arguments);

        this.chart = null;
        this.colors = [];

        // Bindings
        this.workloads = [];
    }

    $onInit() {
        if (!this.chart) {
            this.createChart();
        }
    }

    set workloads(workloads) {
        if (workloads) {
            if (Array.isArray(workloads)) {
                if (workloads.length > 0) {
                    this.colors = _(workloads)
                        .flatMap(workload => workload.colors)
                        .uniq()
                        .value();
                } else {
                    this.colors = [];
                }

            } else {
                this.colors = workloads.colors;
            }

        }else {
            this.colors = [];
        }

        this.updateChart();
    }

    updateChart() {
        if(!this.chart){
            return;
        }

        let data = _(this.colors)
            .map(color => {
                return {
                    name: color.name,
                    value: color.duration,
                    count: color.count,
                    color: color.code
                }
            })
            .value();

        this.chart.series[0].setData(data);
        this.chart.setSize(null, null, false);
    }

    createChart() {
        this.chart = Highcharts.chart('chart-workload-colors-map-hs', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: 0,
                plotShadow: false,
                spacingBottom: 10,
                spacingTop: 10,
                spacingLeft: 0,
                spacingRight: 0
            },

            title: {
                text: ''
            },

            tooltip: {
                enabled: false
            },

            plotOptions: {
                series: {
                    enableMouseTracking: false
                }
            },

            series: [{
                type: "treemap",
                layoutAlgorithm: 'stripes',

                dataLabels: {
                    enabled: true,
                    format: '{point.count}',
                    style: {
                        color: 'white',
                        fontSize: "14px",
                        fontWeight: '600',
                        fontFamily: '-apple-system, "Helvetica Neue", Roboto, "Segoe UI", sans-serif',
                        textShadow: null,
                        textOutline: null
                    }
                },

                data: []
            }]
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/chart-workload-colors-map/chart-workload-colors-map.controller.js